import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'
import type { Optional } from '@/types'

export class TmAuthNeedVerifyPhoneError extends TmAuthError {
  public get email(): Optional<string> {
    return this.data?.data?.email || undefined
  }
}
